/**
 * Supabase Client Configuration
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Supabase URL und Anon Key müssen in der .env Datei definiert sein:\n' +
    'VITE_SUPABASE_URL=your_supabase_url\n' +
    'VITE_SUPABASE_ANON_KEY=your_anon_key'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// ============================================================================
// Storage Configuration
// ============================================================================

export const STORAGE_BUCKET = 'images';

/**
 * Get public URL for a storage path
 */
export const getImageUrl = (storagePath: string): string => {
  const { data } = supabase.storage
    .from(STORAGE_BUCKET)
    .getPublicUrl(storagePath);
  
  return data.publicUrl;
};
